import React from 'react';
import {
  Events,
  Categories,
  useGATrackEvent,
  AnalyticsAttributes,
} from '@app/analytics';
import { trackEvent as segmentTrackEvent, EVENTS, SCREENS } from '@app/segment';
import { useBannerCollage } from './hooks';
import { Loading } from './Loading';
import DesktopBannerCollage from './components/DesktopBannerCollage';
import MobileBannerCollage from './components/MobileBannerCollage';
import { BannerCollageProps, TrackEventProps } from './types';

const BannerCollage = ({ collage, displayType }: BannerCollageProps) => {
  const { bannerCollage, loading, error } = useBannerCollage(collage);
  const gaTrack = useGATrackEvent();

  const handleTrackingEvent = ({
    trackingEvent,
    destination,
    URL,
    bannerSize,
  }: TrackEventProps) => {
    gaTrack(Events.BannerCollageClicked, Categories.Home, trackingEvent, null, {
      [AnalyticsAttributes.cdBannerCollageName]: bannerCollage?.title,
      [AnalyticsAttributes.cdDestinationType]: destination,
    });

    segmentTrackEvent(EVENTS.BANNER_COLLAGE_CLICKED, {
      bannerCollageTitle: bannerCollage?.title,
      bannerSize,
      destination,
      screenName: SCREENS.HOME,
      trackingEvent,
      URL,
    });
  };

  const handleTrackingImpression = (trackingEvent) => {
    segmentTrackEvent(EVENTS.BANNER_COLLAGE_ITEM_IMPRESSION, {
      bannerCollageTitle: bannerCollage?.title,
      screenName: SCREENS.HOME,
      trackingEvent,
    });

    gaTrack(
      Events.BannerCollageItemImpression,
      Categories.Home,
      trackingEvent,
      null,
      {
        [AnalyticsAttributes.cdBannerCollageName]: bannerCollage?.title,
      },
    );
  };

  if (loading) {
    return <Loading displayType={displayType} />;
  }

  if (error || !bannerCollage) {
    return null;
  }

  return (
    <>
      <MobileBannerCollage
        collage={collage}
        handleTrackingEvent={handleTrackingEvent}
        handleTrackingImpression={handleTrackingImpression}
      />
      <DesktopBannerCollage
        collage={collage}
        displayType={displayType}
        handleTrackingEvent={handleTrackingEvent}
        handleTrackingImpression={handleTrackingImpression}
      />
    </>
  );
};

export default BannerCollage;
